export const UNEXPECTED_ERROR = 'unexpected error'
